module.exports = __webpack_public_path__ + "img/box.be5030ca.webp";